export const SuperAdmin_Role = 'SuperAdmin';
export const Admin_Role = 'Admin';
export const Broker_Role = 'Broker';
export const AynBroker_Role = Broker_Role;
export const AgencyBroker_Role = Broker_Role;
export const Agency_Role = 'Agency';
export const Client_Role = 'Client';
export const Developer_Role = 'Developer';
export const KYC_Editor_Role = 'KYC_Editor';
export const Public_Role = 'Public';
